import React, { useEffect, useState } from "react";
import { CircularProgressbarWithChildren } from "react-circular-progressbar";
import clsx from "clsx";

const DEFAULT_DELAY = 5;

const Counter = (props) => {
  const { counterTimeout, onTimeout, color = "danger" } = props;
  const delay = counterTimeout || DEFAULT_DELAY;

  const [counter, setCounter] = useState(delay * 10);

  const preciseCounter = Number.parseFloat(counter / 10).toFixed(1);
  const percentCounter = (counter / (delay * 10)) * 100;

  useEffect(() => {
    if (counter > 0) {
      const timer = setTimeout(() => setCounter(counter - 1), 100);
      return () => clearTimeout(timer);
    } else {
      onTimeout();
    }
  }, [counter, onTimeout]);

  return (
    <CircularProgressbarWithChildren
      value={percentCounter}
      strokeWidth={10}
      className={clsx("m-3", "circular-progress-" + color)}
    >
      {counter > 0 && <span className={clsx("badge", "badge-" + color, "badge-pill")}>{preciseCounter}</span>}
    </CircularProgressbarWithChildren>
  );
};

export default Counter;
